module.exports = __webpack_public_path__ + "img/profile_pic.b2f5d02b.png";